const getDriverByColor = (fillColor: string): string => {
	return `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
				<circle opacity="0.24" cx="20" cy="20" r="12" fill="${fillColor}"/>
				<circle cx="20" cy="20" r="8" fill="${fillColor}"/>
				<circle cx="20" cy="20" r="8" fill="black" fill-opacity="0.56"/>
				<rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="${fillColor}"/>
			</svg>`;
};

const offlineDriver = `<svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="20" cy="20.5" r="12" fill="#718096"/>
		<circle cx="20" cy="20.5" r="8" fill="#F8FAFB"/>
	</svg>`;

export const iconsProvider = {
	getDriverByColor,
	offlineDriver
};
